import { ApolloClient, InMemoryCache } from "@apollo/client";

export const gq = new ApolloClient({
  cache: new InMemoryCache(),
  uri: "https://zed-ql.zed.run/graphql",
  defaultOptions: {
    query: {
      fetchPolicy: "no-cache",
    },
  },
  headers: {
    authorization:
      "Bearer eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJjcnlwdG9maWVsZF9hcGkiLCJleHAiOjE2NDY0NDAzOTYsImlhdCI6MTY0NDAyMTE5NiwiaXNzIjoiY3J5cHRvZmllbGRfYXBpIiwianRpIjoiMjAwZDY4NDUtNjczYi00ZDdiLWIwYjQtYjNiNTZkMGIzNDg1IiwibmJmIjoxNjQ0MDIxMTk1LCJzdWIiOnsiZXh0ZXJuYWxfaWQiOiIxNzlkMTZmYi0wMmU1LTRhNmItOGYwMy1kOTQ2MWRkNGM2NjUiLCJpZCI6Mzc0MjE0LCJwdWJsaWNfYWRkcmVzcyI6IjB4MjU5Nzg4M0MzYWQ2MWU2ODcxZDkzM2NmMTM5OTA5ZEJmMTFCMWEzNSIsInN0YWJsZV9uYW1lIjoic3RhYmxlIDk4NDMwMjYyIn0sInR5cCI6ImFjY2VzcyJ9.BEzAyg-1aMwwegmTn2Qfd9PNEgf1ZtamUf3u3QScZpB0Ffdea-FXHnRFMp1mkuniwOjz2mvk-9iTHqGVOUT7fQ",
  },
});
